import { Component, Input, OnChanges } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { TranslateService } from '@ngx-translate/core';
import { AreaDistributionItem } from '../../../../services/collects-analytics/collects-analytics.model';
import { GetAdminOrganisationAreas } from '../../../../global.model';

@Component({
    selector: 'app-collects-area-chart',
    templateUrl: './collects-area-chart.component.html',
    styleUrls: ['./collects-area-chart.component.scss'],
})
export class CollectsAreaChartComponent implements OnChanges {
    @Input() data: AreaDistributionItem[] = [];
    @Input() areas: GetAdminOrganisationAreas[] = [];

    chartData: ChartConfiguration<'bar'>['data'] = { labels: [], datasets: [] };

    chartOptions: ChartConfiguration<'bar'>['options'] = {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
        plugins: { legend: { display: false } },
        scales: {
            x: { beginAtZero: true, ticks: { precision: 0 } },
            y: { grid: { display: false } },
        },
    };

    private fallbackPalette = ['#3a7bd5', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#06b6d4', '#f97316', '#14b8a6', '#6366f1'];

    constructor(private translate: TranslateService) {}

    private resolveAreaName(area: GetAdminOrganisationAreas): string {
        const name = area.name as any;
        if (typeof name === 'string') return name;
        return name[this.translate.currentLang] || name['fr'] || name['en'] || String(name);
    }

    areaStats: { name: string; count: number; userCount: number; rate: number }[] = [];

    ngOnChanges(): void {
        if (!this.data || this.data.length === 0) return;

        const areaMap = new Map(this.areas.map((a) => [a._id, this.resolveAreaName(a)]));

        this.areaStats = this.data.map((d) => {
            const name = areaMap.get(d.label) || d.label;
            const rate = d.userCount > 0 ? +((d.count / d.userCount) * 100).toFixed(1) : 0;
            return { name, count: d.count, userCount: d.userCount, rate };
        });

        this.chartData = {
            labels: this.areaStats.map((a) => a.name),
            datasets: [
                {
                    data: this.data.map((d) => d.count),
                    backgroundColor: this.data.map((_, i) => this.fallbackPalette[i % this.fallbackPalette.length]),
                    borderRadius: 4,
                },
            ],
        };
    }
}
